import React, { useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Icon, inputCss } from '../components/ui';
import logoImg from '../assets/mema-logo.png';

export default function Login() {
  const [loginOuEmail, setLoginOuEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        { login_ou_email: loginOuEmail.trim().toLowerCase(), senha },
        { withCredentials: true }
      );
      login(res.data.tipo, res.data.usuario_id);
      navigate('/home');
    } catch (err) {
      const errMsg = err.response?.data?.erro || 'Credenciais inválidas';
      setMsg(errMsg);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setMsg(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); }, []);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-canvas)', padding: '24px 16px',
    }}>
      <div style={{
        width: '100%', maxWidth: 360,
        background: 'var(--bg-surface)', borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-lg)', overflow: 'hidden',
        border: '1px solid var(--border-hairline)',
      }}>
        {/* Logo header */}
        <div style={{
          padding: '32px 24px 24px', textAlign: 'center',
          borderBottom: '1px solid var(--border-hairline)',
        }}>
          <img src={logoImg} alt="Aulas da Mema" style={{ height: 100, width: 'auto', margin: '0 auto 4px' }}/>
          <div style={{ fontSize: 13, color: 'var(--text-tertiary)', marginTop: 4 }}>
            Faça login para continuar
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: 12, fontWeight: 540, color: 'var(--text-secondary)' }}>Login ou e-mail</label>
            <div style={{ position: 'relative' }}>
              <div style={{
                position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
                color: 'var(--text-tertiary)', pointerEvents: 'none',
              }}>
                <Icon name="user" size={15}/>
              </div>
              <input
                type="text"
                value={loginOuEmail}
                onChange={e => setLoginOuEmail(e.target.value)}
                autoCapitalize="off" autoCorrect="off" required
                placeholder="seu.login ou email@exemplo.com"
                style={{ ...inputCss, paddingLeft: 36 }}
              />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: 12, fontWeight: 540, color: 'var(--text-secondary)' }}>Senha</label>
            <div style={{ position: 'relative' }}>
              <div style={{
                position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
                color: 'var(--text-tertiary)', pointerEvents: 'none',
              }}>
                <Icon name="settings" size={15}/>
              </div>
              <input
                type="password"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                required placeholder="••••••••"
                style={{ ...inputCss, paddingLeft: 36 }}
              />
            </div>
          </div>

          {msg && (
            <div style={{
              fontSize: 13, padding: '8px 12px', borderRadius: 'var(--radius-sm)',
              background: 'color-mix(in oklch, var(--danger) 10%, transparent)',
              color: 'var(--danger)',
            }}>{msg}</div>
          )}

          <button type="submit" disabled={loading} style={{
            height: 44, marginTop: 4, border: 'none', borderRadius: 'var(--radius-md)',
            background: 'var(--accent)', color: 'var(--accent-fg)',
            fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit', opacity: loading ? 0.7 : 1,
            transition: 'opacity .12s',
          }}>
            {loading ? 'Entrando…' : 'Entrar'}
          </button>
        </form>

        <div style={{
          padding: '0 24px 24px', textAlign: 'center',
        }}>
          <button onClick={() => navigate('/cadastro')} style={{
            fontSize: 13, color: 'var(--accent)', background: 'none', border: 'none',
            cursor: 'pointer', fontFamily: 'inherit', fontWeight: 540,
          }}>
            Não tem conta? Criar cadastro
          </button>
        </div>
      </div>
    </div>
  );
}
